module.exports = __webpack_public_path__ + "img/ciup-ret.8642ac26.jpg";